module.exports = __webpack_public_path__ + "static/media/C1.a9c6a5a7.jpg";